// 1_utils/raventic_config.js
// Per-language, NON-string Raventic config (API keys, locale, currency, search URLs)
// for the search widgets. The UI *strings* live in 0_global/translations.js; this holds
// the per-mutation config that isn't translatable. Consumed by the Raventic setup
// components via window.NAT.raventic[window.NAT.lang].

window.NAT = window.NAT || {};

window.NAT.raventic = window.NAT.raventic || {
	cs: {
		apiKey: "euc28f5007d854bb5b8b89120288e45",
		bestsellersApiKey: "euc28f5007d854bb5b8b89120288e45",
		locale: "cs-CZ",
		currency: "CZK",
		priceDecimals: 0,
		// Dropdown: where Enter / the "show all" button submits the query.
		submitUrl: "https://www.natima.cz/vyhledavani/",
		// Results: substring the page URL must contain for the results widget to run.
		resultsUrlMatch: "www.natima.cz/vyhledavani",
	},
	sk: {
		apiKey: "euca0e3736860cd1072be643e4e32e5",
		bestsellersApiKey: "euca0e3736860cd1072be643e4e32e5",
		locale: "sk-SK",
		currency: "EUR",
		priceDecimals: 2,
		submitUrl: "https://www.natima.sk/vyhladavanie/",
		resultsUrlMatch: "www.natima.sk/vyhladavanie",
	},
	pl: {
		apiKey: "euc8c5f31012cea7c050d4b3c2d0467",
		bestsellersApiKey: "euc8c5f31012cea7c050d4b3c2d0467",
		locale: "pl-PL",
		currency: "PLN",
		priceDecimals: 2,
		submitUrl: "https://www.natima.pl/wyszukiwanie/",
		resultsUrlMatch: "www.natima.pl/wyszukiwanie",
	},
};

const SEARCH_PATH_BY_LANG = {
	cs: "/vyhledavani/",
	sk: "/vyhladavanie/",
	pl: "/wyszukiwanie/",
};

const host = location.hostname;
const isCloneOrLocal =
	host === "localhost" ||
	host === "127.0.0.1" ||
	host.endsWith(".myshoptet.com") ||
	host.startsWith("local.");

if (isCloneOrLocal) {
	Object.entries(SEARCH_PATH_BY_LANG).forEach(function ([lang, path]) {
		const config = window.NAT.raventic[lang];
		if (!config) return;
		config.submitUrl = location.origin + path;
		config.resultsUrlMatch = path.slice(0, -1);
	});
}
